"use client";

import { useEffect } from "react";
import { useLanguage } from "@/features/i18n/hooks/use-language";
import i18n from "@/features/i18n/lib";

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage();

  useEffect(() => {
    if (i18n.language !== language) {
      void i18n.changeLanguage(language);
    }
  }, [language]);

  return <>{children}</>;
}
